<template>
  <div
    :class="classes"
    :style="styles"
  />
</template>

<script setup lang="ts">
interface Props {
  theme: 'opacity' | 'normal'
  duration: string | number
  width?: string
  height: string
}

const props = withDefaults(defineProps<Props>(), {
  theme: 'normal',
  duration: 1,
  width: '100%',
})

const classes = computed(() => {
  let classList: string[] = []
  classList.push('c-skeleton')

  if (props.theme === 'opacity') {
    classList.push('c-skeleton--opacity')
  }

  return classList
})

const styles = computed(() => {
  let styleList: string[] = []
  styleList.push(`--width: ${props.width}`)
  styleList.push(`--height: ${props.height}`)
  styleList.push(`--duration: ${props.duration}`)

  return styleList
})
</script>

<script lang="ts">
import { computed, defineComponent } from 'vue'

export default defineComponent({
  name: 'CSkeleton',
})
</script>
